import React from 'react' // eslint-disable-line no-unused-vars
import DownloadableDocumentsTable from './DownloadableDocumentsTable'
import ListPagination from '../digitalAssistant/ListPagination'
import { connect } from 'react-redux'
import { scrollElementIntoView } from '../../pages/functions'

const ALL = 'All'
const ALL_LANGUAGES = 'All languages'

class PaginatedDocumentsTable extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      items: this.initializeTableItems(props),
      pageNumber: 1,
      pageSize: props.showMobileVersion ? 2 : 10,
      documentLanguage: ALL
    }
  }

  initializeTableItems = props => {
    if (!props.results) {
      return []
    }
    return props.results.map(item => ({
      ...item,
      disableDownload: false,
      hidden: false
    }))
  }

  handlePageChange = (paginationMapKey, pageNumber) => {
    // paginationMapKey is not relevant to this page, since a paginationMap has not been initialized
    this.setState({
      pageNumber
    }, () => scrollElementIntoView(`${this.props.id}-pagination`, this.props.navExpandBreakpoint))
  }

  handleItemStatusChange = (id, disableDownload) => {
    const items = this.state.items.map(item => item.id === id ? { ...item, disableDownload} : item)
    this.setState({ items })
  }

  handlePageSizeChange = e => {
    const pageSize = e.target.value
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  handleLanguageChange = e => {
    const documentLanguage = e.target.value

    let items
    if (documentLanguage === ALL) {
      items = this.state.items.map(item => ({ ...item, hidden: false }))
    } else {
      items = this.state.items.map(item => ({ ...item, hidden: item.parent.language__v[0] !== documentLanguage }))
    }

    this.setState({
      documentLanguage,
      items,
      pageNumber: 1
    })
  }

  getUniqueLanguages = results => {
    const languageMap = results.reduce((map, result) => {
      map[result.parent.language__v[0]] = true
      return map
    }, {})

    return Object.keys(languageMap)
  }

  getLanguageLabel = language => {
    if (this.props.showMobileVersion && language === ALL) {
      return ALL_LANGUAGES
    }
    return language
  }

  render () {
    const { id, pageContent, results, columnNames, columnKeys, searchedProductCode, searchAuditId, showMobileVersion } = this.props
    const languageContent = pageContent.content.module.searchDocument
    const displayedItems = this.state.items.filter(item => !item.hidden)
    const totalPages = Math.ceil(displayedItems.length / this.state.pageSize)
    const paginatedResults = displayedItems
      .slice((this.state.pageNumber - 1) * this.state.pageSize, this.state.pageNumber * this.state.pageSize)

    const documentLanguages = this.getUniqueLanguages(results)
    const languageOptions = [ALL, ...documentLanguages].map((language, index) =>
      <option key={index} value={language}>
        {this.getLanguageLabel(language)}
      </option>)

    return (
      <div className={totalPages === 1 ? 'mb-4' : ''} id={`${id}-pagination`}>
        {
          showMobileVersion &&
          <div className='results-header'>
            <span style={{ fontWeight: 'bold' }}>{languageContent.SearchResult}</span>
            {`: ${displayedItems.length}`}
          </div>
        }
        <div className='mb-3 align-pagination-right'>
          {
            !showMobileVersion &&

            <React.Fragment>

                <h3 className='section-header' style={{ marginTop: '0px', marginBottom: '0px' }}>
                  {languageContent.searchResults}
                </h3>

              <div>
                {languageContent.matchingDocuments}:&nbsp;
                <span style={{ fontWeight: 'bold', paddingRight: '8px' }}>
                  {displayedItems.length}
                </span>
              </div>
              <div>{languageContent.DocumentLanguage}</div>
            </React.Fragment>
          }
          <div>
            <select
              className='custom-select'
              value={this.state.documentLanguage}
              onChange={this.handleLanguageChange}
            >
              {languageOptions}
            </select>
          </div>
          <div>
            {languageContent.ItemsPerPage}
            <select
              className='custom-select m-l-10'
              value={this.state.pageSize}
              onChange={this.handlePageSizeChange}
            >
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='10'>10</option>
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
            </select>
          </div>
        </div>

        <DownloadableDocumentsTable
          id={id}
          items={paginatedResults}
          columnNames={columnNames}
          columnKeys={columnKeys}
          searchedProductCode={searchedProductCode}
          searchAuditId={searchAuditId}
          handleItemStatusChange={this.handleItemStatusChange}
          showMobileVersion={showMobileVersion}
        />

        <div className='mobile-color'>
          <ListPagination
            pageNumber={this.state.pageNumber}
            pageSize={this.state.pageSize}
            totalPages={totalPages}
            setPageNumber={this.handlePageChange}
            paginationMapKey={null}
            backgroundColor={showMobileVersion ? '#f1f1f1' : 'white'}
          />
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent,
    navExpandBreakpoint: state.navigation[1].expandBreakpoint
  }
}

export default connect(mapStateToProps)(PaginatedDocumentsTable)



// WEBPACK FOOTER //
// ./src/mi-app/tables/PaginatedDocumentsTable.js